import { render, staticRenderFns } from "./ServiceCounter.vue?vue&type=template&id=99ba8c1c&scoped=true&lang=pug"
import script from "./ServiceCounter.vue?vue&type=script&lang=ts"
export * from "./ServiceCounter.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCounter.vue?vue&type=style&index=0&id=99ba8c1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ba8c1c",
  null
  
)

export default component.exports